export default "__VITE_ASSET__BUSoyoFu__"